module.exports = __webpack_public_path__ + "e04db6afba742df1cec68542db20d655.png";